<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Preface#uoIjzxohfFhbPpHcxMkB2WF">PREFACE</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Prologue#uy8ITfFKzdr8ZMHWQnav98F">PROLOGUE</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_01#u94uMWPCBwXZy5eQ4XxULMB">CHAPTER 1</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_02#uFkD8oFjHSKSVyL4k2rpY6C">CHAPTER 2</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_03#uYMUKgDagexALtkPQLA2s97" title="Link target outside of Sample">CHAPTER 3</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_04#uKzb6cBtE9S3uvbjFvYuknE" title="Link target outside of Sample">CHAPTER 4</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_05#uen4hWpSNTcxNQsSQ7ayxiG" title="Link target outside of Sample">CHAPTER 5</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_06#uPJ4KDBWuJQiOhXxHtaabe8" title="Link target outside of Sample">CHAPTER 6</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_07#uTgxMfxptstgMJvBVhnkXZ3" title="Link target outside of Sample">CHAPTER 7</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_08#u4mYD6hFTCNcnLApC67u6Q5" title="Link target outside of Sample">CHAPTER 8</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_09#u3WRsqmvGDKd9ETfMcyi4KA" title="Link target outside of Sample">CHAPTER 9</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_10#uwkBm6xG39YYd5ZSjkJKQf4" title="Link target outside of Sample">CHAPTER 10</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_11#unrbLUDCMIxflDC3RG286J2" title="Link target outside of Sample">CHAPTER 11</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_12#uc6CUiLi6XiSoligcd4Ned8" title="Link target outside of Sample">CHAPTER 12</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_13#uGjjQSH3yezkQVHvWJiMUF4" title="Link target outside of Sample">CHAPTER 13</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_14#uuZ3rEWCfEkdHRPjkQAeqm3" title="Link target outside of Sample">CHAPTER 14</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_15#uHFoNOUSGIRpEiFrLOtjKNB" title="Link target outside of Sample">CHAPTER 15</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_16#ueyNIUVkHILgTrUrE5VSIbG" title="Link target outside of Sample">CHAPTER 16</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_17#uqEwKKfM5MbjYm9qncvSih6" title="Link target outside of Sample">CHAPTER 17</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_18#uVi9Ieu9XWmoOu5KLOhyiXB" title="Link target outside of Sample">CHAPTER 18</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_19#uTWdQtusDAJ5TtCVyWnK6o5" title="Link target outside of Sample">CHAPTER 19</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_20#urf3JO384No7tSHEiGibUP7" title="Link target outside of Sample">CHAPTER 20</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Epilogue#u4FCTApElyQQZXWiXYaurH2" title="Link target outside of Sample">EPILOGUE</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Ack#uqVxdZfbn8nJgLImrJdqq69" title="Link target outside of Sample">ACKNOWLEDGEMENTS</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Biblio#uKLt5fMq2ffiCcdZp3IGpK6" title="Link target outside of Sample">BIBLIOGRAPHY</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?512f0e11